import { CustomFields } from "@tr/models"
import { TrDatePipe } from "@tr/pipes"

export function handleColumnCustomFields(dataItem: any, key: string, customFields: CustomFields): string {
  if (key.includes("customFields")) {
    if (!dataItem.customFields && !customFields) { return "" }
    const field = key.replace("customFields.", "")
    let customField = dataItem && dataItem.customFields ? dataItem.customFields[field] : null
    if (!customField) { customField = customFields[field] }
    if (!customField) { return "" }
    switch (customField.type) {
    case "date":
      return new TrDatePipe().transform(customField.value, "short").toLowerCase()
    case "checkbox":
      return customField.value === true ? "true" : customField.value === false ? "false" : ""
    default:
      return `${customField.value}` as string
    }
  }

  return dataItem[key]
}

export function toCamelCase(str: string): string {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, "")
}
